<template>
  <v-card class="funnel-card">
    <div class="d-flex align-center mb-6">
      <img :src="require('@/assets/icons/mar.ia-cor.svg')" alt="mar.ia" style="height: 24px" class="mr-3" />
      <span class="funnel-title">Funil de conversão</span>
    </div>
    <mf-funnel-graph
      full-width
      :labels="labels"
      :label-values="labelValues"
      :percentage-values="percentageValues"
      :sub-labels="subLabels"
      :tooltip-revenue="tooltipRevenue"
      :tooltip-percentage="tooltipPercentage"
      :label-revenues="labelRevenues"
      :height="height"
      :width="width"
      :data-set-num="dataSetNum"
      :sub-label-value="subLabelValue"
      :values="funnelChartData"
      :colors="colors"
      :direction="direction"
      :loading="$apollo.loading"
      :gradient-direction="gradientDirection"
    />
  </v-card>
</template>

<script>
import { getOfferTypeName } from '@/modules/campanhas/gestao-ofertas-v2/helpers/offerType.js'

export default {
  name: 'CustomersTypesFunnelGraph',
  props: {
    funilMetrics: {
      type: Object,
      default: () => ({}),
    },
    campaign: {
      type: Object,
      default: null,
    },
    offerType: {
      type: String,
      default: null,
    },
  },
  data: () => ({
    labels: [
      'Clientes do segmento',
      'Clientes que compraram no período',
      'Clientes que compraram algum dos produtos da(s) oferta(s)',
      'Clientes que compraram apenas os produtos da(s) oferta(s)',
    ],
    tooltipRevenue: 'Faturamento que esses clientes geraram',
    tooltipPercentage: 'Porcentagem dos clientes do segmento',
    height: 150,
    width: 800,
    dataSetNum: 1,
    subLabelValue: 'percent',
    direction: 'horizontal',
    gradientDirection: 'horizontal',
    colors: [
      ['#09535C', '#09535C'],
      ['#09535C', '#09535C'],
      ['#09535C', '#09535C'],
      ['#09535C', '#09535C'],
    ],
  }),

  computed: {
    subLabels() {
      return []
    },
    currentOfferTypeName() {
      if (this.offerType) {
        return getOfferTypeName(this.offerType)
      }
      if (this.campaign?.types && this.campaign.types.length > 0) {
        return getOfferTypeName(this.campaign.types[0])
      }
      return 'general'
    },
    distributedSales() {
      if (this.campaign?.campaignMetrics?.[this.currentOfferTypeName]?.clients_metrics?.distributed_sales) {
        return this.campaign.campaignMetrics[this.currentOfferTypeName].clients_metrics.distributed_sales
      }
      return this.funilMetrics?.general?.clients_metrics?.distributed_sales || {}
    },
    labelValues() {
      return [
        this.distributedSales?.segment?.count || 0,
        this.distributedSales?.bought?.count || 0,
        this.distributedSales?.with_sales?.count || 0,
        this.distributedSales?.with_only_sales?.count || 0,
      ]
    },
    percentageValues() {
      const maxValue = Math.max(...this.labelValues)
      const roundPoint = (number) => Math.round(number * 10) / 10
      return this.labelValues.map((value) => (value === 0 || maxValue === 0 ? 0 : roundPoint((value * 100) / maxValue)))
    },
    labelRevenues() {
      return [
        this.distributedSales?.segment?.revenue || 0,
        this.distributedSales?.bought?.revenue || 0,
        this.distributedSales?.with_sales?.revenue || 0,
        this.distributedSales?.with_only_sales?.revenue || 0,
      ]
    },
    funnelChartData() {
      const values = this.labelValues
      return values.map((v) => [v])
    },
  },
}
</script>

<style lang="scss" scoped>
.funnel-card {
  padding: 24px 40px 32px 20px;
}

.funnel-title {
  font-size: 18px;
  font-weight: 400;
  color: #4b525a;
}

::v-deep .label__title {
  max-width: 220px;
}
</style>
